var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostsList',{attrs:{"resource":_vm.resource,"columns":_vm.headers,"title":"Новости","add-route":{ name: 'news-post' },"store":"newsPosts","path":"news"}})}
var staticRenderFns = []

export { render, staticRenderFns }